import type { JSX } from 'react'
import type { IActionButtonProps } from 'atoms/ActionButton'
import type { IDropdownHeaderProps } from '../DropdownHeader'

import { ActionButton } from 'atoms/ActionButton'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFonts,
  IconPositions,
} from 'atoms/Button'
import { IconNames } from 'atoms/Icon'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import { DropdownHeader } from '../DropdownHeader'

export interface IDropdownHeaderLanguageProps extends Omit<
  IDropdownHeaderProps,
  'children'
> {
  title?: IActionButtonProps['title']
  icon?: IActionButtonProps['icon']
  dataTestId?: string
  font?: ButtonFonts
}

export const DropdownHeaderLanguage = ({
  title = '',
  icon = IconNames.angleDown,
  dataTestId = '',
  font = ButtonFonts.FontSmBold,
  ...rest
}: IDropdownHeaderLanguageProps): JSX.Element => (
  <DropdownHeader {...rest}>
    <ActionButton
      onClick={rest.onClick}
      title={title}
      icon={icon}
      iconPosition={IconPositions.Right}
      dataTestId={dataTestId}
      font={font}
      corners={ButtonCorners.CORNERS_10}
      borderWidth={ButtonBordersWidth.BORDER_0}
      paddings={[FIXED_INDENTS.INDENT_0]}
      colorDefault={ButtonColors.COLOR_TEXT_SECONDARY}
      colorDisabled={ButtonColors.COLOR_DISABLED}
      backgroundColorDefault={COLOR.TRANSPARENT}
      backgroundColorHovered={COLOR.TRANSPARENT}
      backgroundColorPressed={COLOR.TRANSPARENT}
      backgroundColorDisabled={COLOR.TRANSPARENT}
    />
  </DropdownHeader>
)
